export function BugIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="currentColor" d="M11 9a1 1 0 100 2h2a1 1 0 100-2h-2z"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.707 3.293a1 1 0 010 1.414L15.94 6.475A6.01 6.01 0 0117.659 9H19a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v1h1a1 1 0 110 2h-1.341A6.003 6.003 0 016.34 18H5a1 1 0 110-2h1v-1H5a1 1 0 110-2h1v-2H5a1 1 0 110-2h1.341a6.01 6.01 0 011.72-2.525L6.292 4.707a1 1 0 011.414-1.414l2.115 2.115A5.985 5.985 0 0112 5c.768 0 1.503.144 2.178.408l2.115-2.115a1 1 0 011.414 0zM8 11a4 4 0 118 0v5a4 4 0 01-8 0v-5z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
